import React from 'react'
import { List, Datagrid, TextField, EditButton, Filter, TextInput, SimpleList, Responsive } from 'react-admin'
import { TableRowList, ListActions, DateField } from '../../../components'

const PromiseFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput className={props.classes.input} variant="filled" label="Name" source="competitionName" alwaysOn fullWidth />
    </Filter>
  )
}

const Actions = (props) => {
  return <ListActions {...props} filters={<PromiseFilter />} />
}

export const PromiseList = (props) => {
  return (
    <List bulkActions={false} filter={{ competition: 27, type: 'table' }} title="Operadores" {...props} actions={<Actions />}>
      <Responsive
        small={
          <SimpleList
            primaryText={(record) => record.subscription.competitionName}
            tertiaryText={(record) => (
              <div>
                <DateField record={record} source="subscription.dateEnd" label="Date end" />
                <DateField record={record} source="subscription.dateIni" label="Date start" />
              </div>
            )}
          />
        }
        medium={
          <Datagrid>
            <TextField source="subscription.competitionName" label="Competition" sortable={false} />
            <DateField source="subscription.dateIni" label="Date start" sortable={false} />
            <DateField source="subscription.dateEnd" label="Date end" sortable={false} />
            <TableRowList>
              <EditButton />
            </TableRowList>
          </Datagrid>
        }
      />
    </List>
  )
}

export default PromiseList
